module.exports = __webpack_public_path__ + "static/media/calculator.1608e97e.svg";